/*
	possible actions
	- quantity : edit the quantity ordered
	- reduce : reduce a certain quantity (by percentage, for reason)
	- remove : remove (orders only)
	- remove-item : delete from list
	- unreduce : unreduce *all* of the quantity
	- unremove : unremove *all* of the quantity
*/

const MODULE = {};

MODULE.reductionReasons = [
  { value: 0, title: 'Abîmé', default: true },
  { value: 1, title: 'Petit' },
  { value: 2, title: 'Presque périmé' },
  { value: 3, title: 'Autre' }
];

MODULE.getPossibleActions = (listType, possibleActions, defaultAction) => {

  const actions = [
		{ value: 'quantity', name: 'Quantité' },
		{ value: 'reduce', name: 'Remise' },
		{ value: 'remove', name: 'Enlever' },
		{ value: 'unreduce', name: 'Dé-remise' },
		{ value: 'unremove', name: 'Remettre' },
  ];
  const defaults = {
    items: ['quantity','reduce','remove'],
    reduced: ['unreduce'],
    removed: ['unremove']
  };

  return actions
		.filter(
			a => _.intersection(possibleActions, defaults[listType]).includes(a)
		)
		.map(a => {
      if(a.value === defaultAction) a.selected = true;
      return a;
    });
  };

MODULE.getRequiredEditKeys = action => {
  let output = ['action'];
  if(!['unreduce','unremove'].includes(action)){
    output.push('quantity');
  }
  if(action === 'reduce'){
    output = output.concat(['reason','percentage']);
  }
  return output;
};

module.exports = MODULE;